import React, { useState, useEffect, useRef } from "react";
import Resizer from "react-image-file-resizer";
import { IconButton, Tooltip } from "@mui/material";
import { PRIMARY_COLOR } from "../constants/theme";
import FrontSVG from "./../assets/teeth_profile/AvatarFront.svg";
import LateralXRaySVG from "./../assets/teeth_profile/LateralXRay.svg";
import PanoramicXraySVG from "./../assets/teeth_profile/PanoramicXRay.svg";
import CompositeAvatarSVG from "./../assets/teeth_profile/CompositeAvatar.svg";
import SmilySVG from "./../assets/teeth_profile/AvatarSmily.svg";
import LeftSVG from "./../assets/teeth_profile/AvatarLeft.svg";
import RightSVG from "./../assets/teeth_profile/AvatarRight.svg";
import BuccalLeftSVG from "./../assets/teeth_profile/BuccalLeft.svg";
import FrontToothSVG from "./../assets/teeth_profile/FrontTooth.svg";
import BuccalRightSVG from "./../assets/teeth_profile/BuccalRight.svg";
import OcclusalUpperSVG from "./../assets/teeth_profile/OcclusalUpper.svg";
import OcclusalLowerSVG from "./../assets/teeth_profile/OcclusalLower.svg";
import { toast } from "react-toastify";
import {
  getPatientbyID,
  updatePatientPictures,
} from "../services/patient/patient.service";
import Config from "../services/config";
import { CiCamera } from "react-icons/ci";
import { IoCloudUploadOutline } from "react-icons/io5";
import Loader from "../components/Loader";

const TeethProfile = () => {
  const email = sessionStorage.getItem("email");
  const patientID = sessionStorage.getItem("patientId");
  const [loading, setLoading] = useState(false);
  const [compositePic, setCompositePic] = useState("");
  const [frontPic, setFrontPic] = useState("");
  const [smilyPic, setSmilyPic] = useState("");
  const [leftPic, setLeftPic] = useState("");
  const [rightPic, setRightPic] = useState("");
  const [frontTootPic, setFrontToothPic] = useState("");
  const [buccalLeftPic, setBuccalLeftPic] = useState("");
  const [buccalRightPic, setBuccalRightPic] = useState("");
  const [occlusalUpperPic, setOcclusalUpperPic] = useState("");
  const [occlusalLowerPic, setOcclusalLowerPic] = useState("");
  const [panoramicXRayPic, setPanoramicXRayPic] = useState("");
  const [lateralXRayPic, setLateralxRayPic] = useState("");

  const [isHovered, setIsHovered] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [isHoveredReset, setIsHoveredReset] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [webCamStatusReset, setWebCamStatusReset] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [webCamStatus, setWebCamStatus] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [imageUploadLoading, setImageUploadLoading] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);

  const [useFrontCamera, setUseFrontCamera] = useState({
    lateral: false,
    panoramic: false,
    composite: false,
    front: false,
    smile: false,
    left: false,
    right: false,
    fronttooth: false,
    buccalleft: false,
    buccalright: false,
    occlusalupper: false,
    occlusallower: false,
  });

  const constraints = {
    video: {
      width: {
        min: 110,
        ideal: 115,
        max: 170,
      },
      height: {
        min: 80,
        ideal: 110,
        max: 170,
      },
    },
  };

  const inputRefLateral = React.useRef(null);
  const inputRefPanoramic = React.useRef(null);
  const inputRefComposite = React.useRef(null);
  const inputRefFront = React.useRef(null);
  const inputRefSmily = React.useRef(null);
  const inputRefLeft = React.useRef(null);
  const inputRefRight = React.useRef(null);
  const inputRefFrontTooth = React.useRef(null);
  const inputRefBuccalLeft = React.useRef(null);
  const inputRefBuccalRight = React.useRef(null);
  const inputRefLOcclusalUpper = React.useRef(null);
  const inputRefOcclusalLower = React.useRef(null);
  const [lateralFile, setLateralFile] = useState();
  const [panoramicFile, setPanoramicFile] = useState();
  const [compositeFile, setCompositeFile] = useState();
  const [frontFile, setFrontFile] = useState();
  const [smilyFile, setSmilyFile] = useState();
  const [leftFile, setLeftFile] = useState();
  const [rightFile, setRightFile] = useState();
  const [frontToothFile, setFrontToothFile] = useState();
  const [buccalLeftFile, setBuccalLeftFile] = useState();
  const [buccalRightFile, setBuccalRightFile] = useState();
  const [occlusalLowerFile, setocclusalLowerFile] = useState();
  const [occlusalUpperFile, setOcclusalUpperFile] = useState();
  const [STLFILE, setSTLFILE] = useState();
  const [STLFILEUpper, setSTLFILEUpper] = useState();
  const [STLFILELower, setSTLFILELower] = useState();

  const camRef = useRef({});
  const canvasRef = useRef({});

  const uploadImpressionImages = async (
    lateralXRay,
    panoramicXRay,
    composite,
    front,
    smily,
    left,
    right,
    frontTooth,
    buccalLeft,
    buccalRight,
    occlusalUpper,
    occlusalLower,
    setImageUploadLoading,
    imageUploadLoading,
    index
  ) => {
    let data = {
      patient_id: patientID,
      email,
      lateral: lateralXRay,
      panoramic: panoramicXRay,
      composite_picture: composite,
      front_picture: front,
      smily_picture: smily,
      left_picture: left,
      right_picture: right,
      front_teeth_picture: frontTooth,
      buccal_left_picture: buccalLeft,
      buccal_right_picture: buccalRight,
      occlusal_upper: occlusalUpper,
      occlusal_lower: occlusalLower,
    };

    Object.keys(data).forEach(
      (k) => (data[k] === "" || data[k] == undefined) && delete data[k]
    );

    try {
      const response = await updatePatientPictures(data);
      if (response?.data.status == 200) {
        let temp = imageUploadLoading;
        temp[index] = false;
        setImageUploadLoading([...temp]);
      } else {
        setLoading(false);
        let temp = imageUploadLoading;
        temp[index] = false;
        setImageUploadLoading([...temp]);
        toast.error(response.data.message);
      }
    } catch (err) {
      setLoading(false);
      let temp = imageUploadLoading;
      temp[index] = false;
      setImageUploadLoading([...temp]);
      if (err.response) {
        toast.error(err.response.data.message?.toString());
      } else if (err.message) {
        toast.error(err.message);
      } else {
        toast.error(err);
      }
    }
  };

  const initializeCamera = async (value, index, camera = false) => {
    Object.keys(camRef.current)?.forEach((item) => {
      camRef.current[item]?.srcObject?.getTracks()?.forEach((track) => {
        track.stop();
      });
    });
    let temp = [...webCamStatusReset];
    temp[index] = true;
    setWebCamStatus([...temp]);
    constraints.video.facingMode = camera ? "user" : "environment";

    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      if (value == "lateral") {
        if (camRef.current["lateral"]) {
          camRef.current["lateral"].srcObject = stream;
        }
      } else if (value == "panoramic") {
        if (camRef.current["panoramic"]) {
          camRef.current["panoramic"].srcObject = stream;
        }
      } else if (value == "composite") {
        if (camRef.current["composite"]) {
          camRef.current["composite"].srcObject = stream;
        }
      } else if (value == "front") {
        if (camRef.current["front"]) {
          camRef.current["front"].srcObject = stream;
        }
      } else if (value == "smile") {
        if (camRef.current["smile"]) {
          camRef.current["smile"].srcObject = stream;
        }
      } else if (value == "left") {
        if (camRef.current["left"]) {
          camRef.current["left"].srcObject = stream;
        }
      } else if (value == "right") {
        if (camRef.current["right"]) {
          camRef.current["right"].srcObject = stream;
        }
      } else if (value == "fronttooth") {
        if (camRef.current["fronttooth"]) {
          camRef.current["fronttooth"].srcObject = stream;
        }
      } else if (value == "buccalleft") {
        if (camRef.current["buccalleft"]) {
          camRef.current["buccalleft"].srcObject = stream;
        }
      } else if (value == "buccalright") {
        if (camRef.current["buccalright"]) {
          camRef.current["buccalright"].srcObject = stream;
        }
      } else if (value == "occlusalupper") {
        if (camRef.current["occlusalupper"]) {
          camRef.current["occlusalupper"].srcObject = stream;
        }
      } else if (value == "occlusallower") {
        if (camRef.current["occlusallower"]) {
          camRef.current["occlusallower"].srcObject = stream;
        }
      }
    } catch (err) {
      let temp2 = webCamStatus;
      temp2[index] = false;
      setWebCamStatus([...temp2]);
      console.log("Err", err);
      alert(err);
    }
  };

  const SwitchCamera = (value, index) => {
    let temp = { ...useFrontCamera };
    temp[value] = !useFrontCamera[value];

    setUseFrontCamera({ ...temp });

    initializeCamera(value, index, temp[value]);
  };

  const UploadImages = (value) => {
    if (value == "lateralFile") {
      let temp = imageUploadLoading;
      temp[0] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        lateralFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        0
      );
    } else if (value == "panoramicFile") {
      let temp = imageUploadLoading;
      temp[1] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        panoramicFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        1
      );
    } else if (value == "compositeFile") {
      let temp = imageUploadLoading;
      temp[2] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        compositeFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        2
      );
    } else if (value == "frontFile") {
      let temp = imageUploadLoading;
      temp[3] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        frontFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        3
      );
    } else if (value == "smilyFile") {
      let temp = imageUploadLoading;
      temp[4] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        smilyFile,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        4
      );
    } else if (value == "leftFile") {
      let temp = imageUploadLoading;
      temp[5] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        leftFile,
        "",
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        5
      );
    } else if (value == "rightFile") {
      let temp = imageUploadLoading;
      temp[6] = true;
      setImageUploadLoading([...temp]);

      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        rightFile,
        "",
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        6
      );
    } else if (value == "frontToothFile") {
      let temp = imageUploadLoading;
      temp[7] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        frontToothFile,
        "",
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        7
      );
    } else if (value == "buccalLeftFile") {
      let temp = imageUploadLoading;
      temp[8] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        buccalLeftFile,
        "",
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        8
      );
    } else if (value == "buccalRightFile") {
      let temp = imageUploadLoading;
      temp[9] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        buccalRightFile,
        "",
        "",
        setImageUploadLoading,
        imageUploadLoading,
        9
      );
    } else if (value == "occlusalUpperFile") {
      let temp = imageUploadLoading;
      temp[10] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        occlusalUpperFile,
        "",
        setImageUploadLoading,
        imageUploadLoading,
        10
      );
    } else if (value == "occlusalLowerFile") {
      let temp = imageUploadLoading;
      temp[11] = true;
      setImageUploadLoading([...temp]);
      uploadImpressionImages(
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        occlusalLowerFile,
        setImageUploadLoading,
        imageUploadLoading,
        11
      );
    }
  };

  const [screenWidth, setScreenWidth] = useState(0);
  console.log(screenWidth);

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  useEffect(() => {
    lateralFile && UploadImages("lateralFile");
  }, [lateralFile]);

  useEffect(() => {
    panoramicFile && UploadImages("panoramicFile");
  }, [panoramicFile]);

  useEffect(() => {
    compositeFile && UploadImages("compositeFile");
  }, [compositeFile]);
  useEffect(() => {
    frontFile && UploadImages("frontFile");
  }, [frontFile]);
  useEffect(() => {
    smilyFile && UploadImages("smilyFile");
  }, [smilyFile]);
  useEffect(() => {
    leftFile && UploadImages("leftFile");
  }, [leftFile]);
  useEffect(() => {
    rightFile && UploadImages("rightFile");
  }, [rightFile]);
  useEffect(() => {
    frontToothFile && UploadImages("frontToothFile");
  }, [frontToothFile]);
  useEffect(() => {
    buccalLeftFile && UploadImages("buccalLeftFile");
  }, [buccalLeftFile]);
  useEffect(() => {
    buccalRightFile && UploadImages("buccalRightFile");
  }, [buccalRightFile]);
  useEffect(() => {
    occlusalUpperFile && UploadImages("occlusalUpperFile");
  }, [occlusalUpperFile]);

  useEffect(() => {
    occlusalLowerFile && UploadImages("occlusalLowerFile");
  }, [occlusalLowerFile]);

  const getPatientData = async () => {
    try {
      setLoading(true);

      const response = await getPatientbyID(email, patientID);

      if (response.status === 200) {
        if (response?.data?.data?.teethProfile) {
          setCompositePic(
            response?.data?.data?.teethProfile?.composite
              ? typeof response?.data?.data?.teethProfile?.composite == "object"
                ? URL.createObjectURL(
                    response?.data?.data?.teethProfile?.composite
                  )
                : Config.filePath +
                  response?.data?.data?.teethProfile?.composite
              : "" || ""
          );

          setFrontPic(
            response?.data?.data?.teethProfile?.front
              ? typeof response?.data?.data?.teethProfile?.front == "object"
                ? URL.createObjectURL(response?.data?.data?.teethProfile?.front)
                : Config.filePath + response?.data?.data?.teethProfile?.front
              : "" || ""
          );

          setSmilyPic(
            response?.data?.data?.teethProfile?.smile
              ? typeof response?.data?.data?.teethProfile?.smile == "object"
                ? URL.createObjectURL(response?.data?.data?.teethProfile?.smile)
                : Config.filePath + response?.data?.data?.teethProfile?.smile
              : "" || ""
          );

          setLeftPic(
            response?.data?.data?.teethProfile?.left
              ? typeof response?.data?.data?.teethProfile?.left == "object"
                ? URL.createObjectURL(response?.data?.data?.teethProfile?.left)
                : Config.filePath + response?.data?.data?.teethProfile?.left
              : "" || ""
          );

          setRightPic(
            response?.data?.data?.teethProfile?.right
              ? typeof response?.data?.data?.teethProfile?.right == "object"
                ? URL.createObjectURL(response?.data?.data?.teethProfile?.right)
                : Config.filePath + response?.data?.data?.teethProfile?.right
              : "" || ""
          );

          setFrontToothPic(
            response?.data?.data?.teethProfile?.frontTooth
              ? typeof response?.data?.data?.teethProfile?.frontTooth ==
                "object"
                ? URL.createObjectURL(
                    response?.data?.data?.teethProfile?.frontTooth
                  )
                : Config.filePath +
                  response?.data?.data?.teethProfile?.frontTooth
              : "" || ""
          );

          setBuccalLeftPic(
            response?.data?.data?.teethProfile?.buccalLeft
              ? typeof response?.data?.data?.teethProfile?.buccalLeft ==
                "object"
                ? URL.createObjectURL(
                    response?.data?.data?.teethProfile?.buccalLeft
                  )
                : Config.filePath +
                  response?.data?.data?.teethProfile?.buccalLeft
              : "" || ""
          );

          setBuccalRightPic(
            response?.data?.data?.teethProfile?.buccalRight
              ? typeof response?.data?.data?.teethProfile?.buccalRight ==
                "object"
                ? URL.createObjectURL(
                    response?.data?.data?.teethProfile?.buccalRight
                  )
                : Config.filePath +
                  response?.data?.data?.teethProfile?.buccalRight
              : "" || ""
          );

          setOcclusalUpperPic(
            response?.data?.data?.teethProfile?.occlusalUpper
              ? typeof response?.data?.data?.teethProfile?.occlusalUpper ==
                "object"
                ? URL.createObjectURL(
                    response?.data?.data?.teethProfile?.occlusalUpper
                  )
                : Config.filePath +
                  response?.data?.data?.teethProfile?.occlusalUpper
              : "" || ""
          );

          setOcclusalLowerPic(
            response?.data?.data?.teethProfile?.occlusalLower
              ? typeof response?.data?.data?.teethProfile?.occlusalLower ==
                "object"
                ? URL.createObjectURL(
                    response?.data?.data?.teethProfile?.occlusalLower
                  )
                : Config.filePath +
                  response?.data?.data?.teethProfile?.occlusalLower
              : "" || ""
          );

          setPanoramicXRayPic(
            response?.data?.data?.teethProfile?.panoramic
              ? typeof response?.data?.data?.teethProfile?.panoramic == "object"
                ? URL.createObjectURL(
                    response?.data?.data?.teethProfile?.panoramic
                  )
                : Config.filePath +
                  response?.data?.data?.teethProfile?.panoramic
              : "" || ""
          );

          setLateralxRayPic(
            response?.data?.data?.teethProfile?.lateral
              ? typeof response?.data?.data?.teethProfile?.lateral == "object"
                ? URL.createObjectURL(
                    response?.data?.data?.teethProfile?.lateral
                  )
                : Config.filePath + response?.data?.data?.teethProfile?.lateral
              : "" || ""
          );
        }
      } else {
        toast.error("Error getting data!");
        return;
      }

      setLoading(false);
    } catch (error) {
      toast.error("ERROR FETCHING DATA!");
      console.log("ERROR FETCHING PATIENT DATA => ", error);
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    getPatientData();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (imageUploadLoading.find((item) => item == true)) {
        event.preventDefault();
        event.returnValue = "";
      } else {
        window.onbeforeunload = null;
      }
    };

    if (imageUploadLoading.find((item) => item == true)) {
      window.addEventListener("beforeunload", handleBeforeUnload);
    } else {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [imageUploadLoading]);

  const handleMouseEnter = (index) => {
    let temp = [...isHoveredReset];
    temp[index] = true;
    setIsHovered([...temp]);
  };

  const handleMouseLeave = (index) => {
    let temp = [...isHoveredReset];
    temp[index] = false;
    setIsHovered([...temp]);
  };

  const convertToFile = async (value, name) => {
    const blob = await fetch(value).then((res) => res.blob());
    const type = "image/webp";
    const file = new File([blob], name, { type });

    if (name == "composite") {
      setCompositeFile(file);
    } else if (name == "front") {
      setFrontFile(file);
    } else if (name == "smily") {
      setSmilyFile(file);
    } else if (name == "left") {
      setLeftFile(file);
    } else if (name == "right") {
      setRightFile(file);
    } else if (name == "fronttooth") {
      setFrontToothFile(file);
    } else if (name == "buccalleft") {
      setBuccalLeftFile(file);
    } else if (name == "buccalright") {
      setBuccalRightFile(file);
    } else if (name == "occlusalupper") {
      setOcclusalUpperFile(file);
    } else if (name == "occlusallower") {
      setocclusalLowerFile(file);
    } else if (name == "panoramic" || name == "panoramicxray") {
      setPanoramicFile(file);
    } else if (name == "lateral" || name == "lateralxray") {
      setLateralFile(file);
    }
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    let imageData = await resizeFile(e.dataTransfer.files[0]);
    convertToFile(imageData, e.target.id);

    if (e.target.id == "composite") {
      // setCompositeFile(e.dataTransfer.files[0]);
      setCompositePic(imageData);
    } else if (e.target.id == "front") {
      // setFrontFile(e.dataTransfer.files[0]);
      setFrontPic(imageData);
    } else if (e.target.id == "smily") {
      // setSmilyFile(e.dataTransfer.files[0]);
      setSmilyPic(imageData);
    } else if (e.target.id == "left") {
      // setLeftFile(e.dataTransfer.files[0]);
      setLeftPic(imageData);
    } else if (e.target.id == "right") {
      // setRightFile(e.dataTransfer.files[0]);
      setRightPic(imageData);
    } else if (e.target.id == "fronttooth") {
      // setFrontToothFile(e.dataTransfer.files[0]);
      setFrontToothPic(imageData);
    } else if (e.target.id == "buccalleft") {
      // setBuccalLeftFile(e.dataTransfer.files[0]);
      setBuccalLeftPic(imageData);
    } else if (e.target.id == "buccalright") {
      // setBuccalRightFile(e.dataTransfer.files[0]);
      setBuccalRightPic(imageData);
    } else if (e.target.id == "occlusalupper") {
      // setOcclusalUpperFile(e.dataTransfer.files[0]);
      setOcclusalUpperPic(imageData);
    } else if (e.target.id == "occlusallower") {
      // setocclusalLowerFile(e.dataTransfer.files[0]);
      setOcclusalLowerPic(imageData);
    } else if (e.target.id == "panoramicxray") {
      // setPanoramicFile(e.dataTransfer.files[0]);
      setPanoramicXRayPic(imageData);
    } else if (e.target.id == "lateralxray") {
      // setLateralFile(e.dataTransfer.files[0]);
      setLateralxRayPic(imageData);
    }
    setIsHovered([...isHoveredReset]);
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1280,
        720,
        "WEBP",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64"
      );
    });

  const handleImageUpload = async (e) => {
    let imageData = await resizeFile(e.target.files[0]);
    await convertToFile(imageData, e.target.id);

    setIsHovered([...isHoveredReset]);
    if (e.target.id == "composite") {
      // setCompositeFile(e.target.files[0]);
      setCompositePic(imageData);
    } else if (e.target.id == "front") {
      // setFrontFile(e.target.files[0]);
      setFrontPic(imageData);
    } else if (e.target.id == "smily") {
      // setSmilyFile(e.target.files[0]);
      setSmilyPic(imageData);
    } else if (e.target.id == "left") {
      // setLeftFile(e.target.files[0]);
      setLeftPic(imageData);
    } else if (e.target.id == "right") {
      // setRightFile(e.target.files[0]);
      setRightPic(imageData);
    } else if (e.target.id == "fronttooth") {
      //   setFrontToothFile(e.target.files[0]);
      setFrontToothPic(imageData);
    } else if (e.target.id == "buccalleft") {
      // setBuccalLeftFile(e.target.files[0]);
      setBuccalLeftPic(imageData);
    } else if (e.target.id == "buccalright") {
      // setBuccalRightFile(e.target.files[0]);
      setBuccalRightPic(imageData);
    } else if (e.target.id == "occlusalupper") {
      // setOcclusalUpperFile(e.target.files[0]);
      setOcclusalUpperPic(imageData);
    } else if (e.target.id == "occlusallower") {
      // setocclusalLowerFile(e.target.files[0]);
      setOcclusalLowerPic(imageData);
    } else if (e.target.id == "panoramicxray") {
      // setPanoramicFile(e.target.files[0]);
      setPanoramicXRayPic(imageData);
    } else if (e.target.id == "lateralxray") {
      // setLateralFile(e.target.files[0]);
      setLateralxRayPic(imageData);
    }
  };

  const stopVideoStream = (value, index) => {
    let temp = { ...useFrontCamera };
    temp[value] = false;
    setUseFrontCamera({ ...temp });

    Object.keys(camRef.current)?.forEach((item) => {
      camRef.current[item]?.srcObject?.getTracks()?.forEach((track) => {
        track.stop();
      });
    });
  };

  return (
    <div className="col-12 px-2">
      <div
        className="container-fluid position-relative"
        style={{
          overflow: "hidden",
          zIndex: "20",
          backgroundColor: "#ffffff",
          borderRadius: "15px",
        }}
      >
        {/* <div className="d-flex mt-4 justify-content-center text-center">
					<h4
						className="text-center"
						style={{
							color: HEADER_COLOR,
						}}
					>
						Teeth Profile
					</h4>
				</div>

				<hr style={{ color: "gray" }} /> */}

        <div
          className="row w-100 mx-auto flex-column align-items-center justify-content-start"
          style={{
            gap: "50px",
          }}
        >
          {/* SECTIONS */}

          <div>
            <h5
              className="text-center"
              style={{
                color: PRIMARY_COLOR,
              }}
            >
              Pictures
            </h5>
            <hr style={{ color: "silver", width: "50%", margin: "auto" }} />
          </div>

          <div
            className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
            style={{
              rowGap: "15px",
              maxWidth: "700px",
            }}
          >
            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative"
            >
              <div
                id="composite"
                onMouseEnter={() => !webCamStatus[2] && handleMouseEnter(2)}
                onMouseLeave={() => !webCamStatus[2] && handleMouseLeave(2)}
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background:
                    !compositePic &&
                    `url(${CompositeAvatarSVG}) no-repeat center`,
                }}
              >
                {isHovered[2] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      // backgroundColor: "rgba(256,256,256,0.4)",
                      backgroundColor: "rgba(256,256,256,0.8)",
                      top: "1px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        // className="mx-2"
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[2] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[2] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("composite", 2);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[2] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[2] = false;
                          setWebCamStatus([...temp2]);

                          inputRefComposite?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[2] && compositePic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="composite"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefComposite}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[2] ? (
                  <img
                    src={compositePic || ""}
                    id="composite"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["composite"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["composite"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[2] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["composite"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["composite"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");
                        setCompositePic(imageSrc);
                        convertToFile(imageSrc, "composite");

                        stopVideoStream("composite");

                        let temp2 = webCamStatus;
                        temp2[2] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[2] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("composite", 2);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("composite");
                        let temp2 = webCamStatus;
                        temp2[2] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[2] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Composite
                </div>
              )}
            </div>

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative"
            >
              <div
                id="front"
                onMouseEnter={() => !webCamStatus[3] && handleMouseEnter(3)}
                onMouseLeave={() => !webCamStatus[3] && handleMouseLeave(3)}
                onDrop={handleDrop}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background: !frontPic && `url(${FrontSVG}) no-repeat center`,
                }}
              >
                {isHovered[3] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[3] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[3] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("front", 3);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[3] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[3] = false;
                          setWebCamStatus([...temp2]);

                          inputRefFront?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}

                {imageUploadLoading[3] && frontPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="front"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefFront}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[3] ? (
                  <img
                    src={frontPic || ""}
                    id="front"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["front"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["front"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[3] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["front"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["front"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");
                        setFrontPic(imageSrc);

                        convertToFile(imageSrc, "front");
                        stopVideoStream("front");
                        let temp2 = webCamStatus;
                        temp2[3] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[3] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Switch Camera">
                    <IconButton onClick={() => SwitchCamera("front", 3)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("front");
                        let temp2 = webCamStatus;
                        temp2[3] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[3] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Front
                </div>
              )}
            </div>

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative"
            >
              <div
                id="smily"
                onMouseEnter={() => !webCamStatus[4] && handleMouseEnter(4)}
                onMouseLeave={() => !webCamStatus[4] && handleMouseLeave(4)}
                onDrop={handleDrop}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background: !smilyPic && `url(${SmilySVG}) no-repeat center`,
                }}
              >
                {isHovered[4] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[4] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[4] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("smile", 4);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[4] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[4] = false;
                          setWebCamStatus([...temp2]);

                          inputRefSmily?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[4] && smilyPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="smily"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefSmily}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[4] ? (
                  <img
                    src={smilyPic || ""}
                    id="smily"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="smily webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["smile"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["smile"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[4] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["smile"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["smile"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");
                        setSmilyPic(imageSrc);
                        convertToFile(imageSrc, "smily");
                        stopVideoStream("smile");
                        let temp2 = webCamStatus;
                        temp2[4] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[4] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("smile", 4);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("smile");
                        let temp2 = webCamStatus;
                        temp2[4] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[4] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Smile
                </div>
              )}
            </div>

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
            >
              <div
                id="left"
                onMouseEnter={() => !webCamStatus[5] && handleMouseEnter(5)}
                onMouseLeave={() => !webCamStatus[5] && handleMouseLeave(5)}
                onDrop={handleDrop}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background: !leftPic && `url(${LeftSVG}) no-repeat center`,
                }}
              >
                {isHovered[5] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[5] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[5] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("left", 5);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[5] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[5] = false;
                          setWebCamStatus([...temp2]);

                          inputRefLeft?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[5] && leftPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}

                {
                  <input
                    id="left"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefLeft}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[5] ? (
                  <img
                    src={leftPic || ""}
                    id="left"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="left webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["left"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["left"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[5] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["left"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["left"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");
                        setLeftPic(imageSrc);
                        convertToFile(imageSrc, "left");
                        stopVideoStream("left");
                        let temp2 = webCamStatus;
                        temp2[5] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[5] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("left", 5);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("left");
                        let temp2 = webCamStatus;
                        temp2[5] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[5] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Left
                </div>
              )}
            </div>

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
            >
              <div
                id="right"
                onMouseEnter={() => !webCamStatus[6] && handleMouseEnter(6)}
                onMouseLeave={() => !webCamStatus[6] && handleMouseLeave(6)}
                onDrop={handleDrop}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background: !rightPic && `url(${RightSVG}) no-repeat center`,
                }}
              >
                {isHovered[6] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[6] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[6] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("right", 6);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[6] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[6] = false;
                          setWebCamStatus([...temp2]);

                          inputRefRight?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[6] && rightPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="right"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefRight}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[6] ? (
                  <img
                    src={rightPic || ""}
                    id="right"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="right webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["right"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["right"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[6] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["right"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["right"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");

                        setRightPic(imageSrc);
                        convertToFile(imageSrc, "right");
                        stopVideoStream("right");
                        let temp2 = webCamStatus;
                        temp2[6] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[6] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("right", 6);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("right");
                        let temp2 = webCamStatus;
                        temp2[6] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[6] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Right
                </div>
              )}
            </div>

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
            >
              <div
                id="buccalleft"
                onMouseEnter={() => !webCamStatus[8] && handleMouseEnter(8)}
                onMouseLeave={() => !webCamStatus[8] && handleMouseLeave(8)}
                onDrop={handleDrop}
                className={
                  "border border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background:
                    !buccalLeftPic && `url(${BuccalLeftSVG}) no-repeat center`,
                }}
              >
                {isHovered[8] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[8] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[8] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("buccalleft", 8);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[8] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[8] = false;
                          setWebCamStatus([...temp2]);

                          inputRefBuccalLeft?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[8] && buccalLeftPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="buccalleft"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefBuccalLeft}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[8] ? (
                  <img
                    src={buccalLeftPic || ""}
                    id="buccalleft"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="buccal left webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["buccalleft"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["buccalleft"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[8] === true && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["buccalleft"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["buccalleft"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");
                        setBuccalLeftPic(imageSrc);
                        convertToFile(imageSrc, "buccalleft");
                        stopVideoStream("buccalleft");
                        let temp2 = webCamStatus;
                        temp2[8] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[8] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("buccalleft", 8);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("buccalleft");
                        let temp2 = webCamStatus;
                        temp2[8] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[8] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Buccal Left
                </div>
              )}
            </div>

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
            >
              <div
                id="fronttooth"
                onMouseEnter={() => !webCamStatus[7] && handleMouseEnter(7)}
                onMouseLeave={() => !webCamStatus[7] && handleMouseLeave(7)}
                onDrop={handleDrop}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background:
                    !frontTootPic && `url(${FrontToothSVG}) no-repeat center`,
                }}
              >
                {isHovered[7] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[7] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[7] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("fronttooth", 7);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[7] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[7] = false;
                          setWebCamStatus([...temp2]);

                          inputRefFrontTooth?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[7] && frontTootPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",
                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="fronttooth"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefFrontTooth}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[7] ? (
                  <img
                    src={frontTootPic || ""}
                    id="fronttooth"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="front tooth webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["fronttooth"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["fronttooth"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[7] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["fronttooth"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["fronttooth"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");
                        setFrontToothPic(imageSrc);
                        convertToFile(imageSrc, "fronttooth");
                        stopVideoStream("fronttooth");
                        let temp2 = webCamStatus;
                        temp2[7] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[7] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("fronttooth", 7);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("fronttooth");
                        let temp2 = webCamStatus;
                        temp2[7] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[7] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Front Tooth
                </div>
              )}
            </div>

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
            >
              <div
                id="buccalright"
                onMouseEnter={() => !webCamStatus[9] && handleMouseEnter(9)}
                onMouseLeave={() => !webCamStatus[9] && handleMouseLeave(9)}
                onDrop={handleDrop}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background:
                    !buccalRightPic &&
                    `url(${BuccalRightSVG}) no-repeat center`,
                }}
              >
                {isHovered[9] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = [...webCamStatus];
                          temp[9] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[9] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("buccalright", 9);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[9] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[9] = false;
                          setWebCamStatus([...temp2]);

                          inputRefBuccalRight?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[9] && buccalRightPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="buccalright"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefBuccalRight}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[9] ? (
                  <img
                    src={buccalRightPic || ""}
                    id="buccalright"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="buccal right webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["buccalright"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["buccalright"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[9] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["buccalright"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["buccalright"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");

                        setBuccalRightPic(imageSrc);
                        convertToFile(imageSrc, "buccalright");
                        stopVideoStream("buccalright");
                        let temp2 = webCamStatus;
                        temp2[9] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[9] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("buccalright", 9);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("buccalright");
                        let temp2 = webCamStatus;
                        temp2[9] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[9] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Buccal Right
                </div>
              )}
            </div>

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
            >
              <div
                id="occlusalupper"
                onMouseEnter={() => !webCamStatus[10] && handleMouseEnter(10)}
                onMouseLeave={() => !webCamStatus[10] && handleMouseLeave(10)}
                onDrop={handleDrop}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background:
                    !occlusalUpperPic &&
                    `url(${OcclusalUpperSVG}) no-repeat center`,
                }}
              >
                {isHovered[10] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[10] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[10] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("occlusalupper", 10);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[10] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[10] = false;
                          setWebCamStatus([...temp2]);

                          inputRefLOcclusalUpper?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[10] && occlusalUpperPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="occlusalupper"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefLOcclusalUpper}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[10] ? (
                  <img
                    src={occlusalUpperPic || ""}
                    id="occlusalupper"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="occlusal upper webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["occlusalupper"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["occlusalupper"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[10] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["occlusalupper"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["occlusalupper"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");
                        setOcclusalUpperPic(imageSrc);
                        convertToFile(imageSrc, "occlusalupper");

                        stopVideoStream("occlusalupper");
                        let temp2 = webCamStatus;
                        temp2[10] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[10] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("occlusalupper", 10);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("occlusalupper");
                        let temp2 = webCamStatus;
                        temp2[10] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[10] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Occlusal Upper
                </div>
              )}
            </div>
            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative "
            >
              <div
                id="occlusallower"
                onMouseEnter={() => !webCamStatus[11] && handleMouseEnter(11)}
                onMouseLeave={() => !webCamStatus[11] && handleMouseLeave(11)}
                onDrop={handleDrop}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                onDragOver={(e) => e.preventDefault()}
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background:
                    !occlusalLowerPic &&
                    `url(${OcclusalLowerSVG}) no-repeat center`,
                }}
              >
                {isHovered[11] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      top: "1px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[11] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[11] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("occlusallower", 11);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[11] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[11] = false;
                          setWebCamStatus([...temp2]);

                          inputRefOcclusalLower?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[11] && occlusalLowerPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="occlusallower"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefOcclusalLower}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[11] ? (
                  <img
                    src={occlusalLowerPic || ""}
                    id="occlusallower"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="occlual lower webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["occlusallower"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["occlusallower"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>

              {webCamStatus[11] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["occlusallower"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["occlusallower"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");
                        setOcclusalLowerPic(imageSrc);
                        convertToFile(imageSrc, "occlusallower");

                        stopVideoStream("occlusallower");
                        let temp2 = webCamStatus;
                        temp2[11] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[11] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("occlusallower", 11);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("occlusallower");
                        let temp2 = webCamStatus;
                        temp2[11] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[11] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Occlusal Lower
                </div>
              )}
            </div>
          </div>

          <div>
            <h5
              className="text-center"
              style={{
                color: PRIMARY_COLOR,
              }}
            >
              Radiography
            </h5>
            <hr style={{ color: "silver", width: "50%", margin: "auto" }} />
          </div>

          <div
            className="row w-100 mx-auto flex-column flex-sm-row align-items-center justify-content-center"
            style={{
              gap: "30px",
            }}
          >
            {/* Lateral */}
            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 position-relative z-20"
            >
              <div
                id="lateralxray"
                onMouseEnter={() => !webCamStatus[0] && handleMouseEnter(0)}
                onMouseLeave={() => !webCamStatus[0] && handleMouseLeave(0)}
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                style={{
                  width: "170px",
                  height: "120px",

                  cursor: "pointer",
                  caretColor: "transparent",
                  background:
                    !lateralXRayPic &&
                    `url(${LateralXRaySVG}) no-repeat center`,
                }}
              >
                {isHovered[0] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                      gap: "20px",
                      zIndex: 99,
                      top: "1px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[0] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[0] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("lateral", 0);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[0] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[0] = false;
                          setWebCamStatus([...temp2]);

                          inputRefLateral?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}

                {imageUploadLoading[0] && lateralXRayPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="lateralxray"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefLateral}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[0] ? (
                  <img
                    src={lateralXRayPic || ""}
                    id="lateralxray"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="lateral x ray webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["lateral"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["lateral"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>
              {webCamStatus[0] === true && (
                <div
                  style={{ width: "170px" }}
                  className="d-flex justify-content-between"
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["lateral"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["lateral"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");

                        setLateralxRayPic(imageSrc);

                        convertToFile(imageSrc, "lateral");
                        stopVideoStream("lateral");
                        let temp2 = webCamStatus;
                        temp2[0] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[0] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("lateral", 0);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("lateral");
                        let temp2 = webCamStatus;
                        temp2[0] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[0] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Lateral
                </div>
              )}
            </div>

            {/* Panoramic */}

            <div
              style={{
                display: screenWidth <= 500 ? "flex" : "",
                flexDirection: screenWidth <= 500 ? "column" : "",
                alignItems: screenWidth <= 500 ? "center" : "",
              }}
              className="col-lg-3 col-md-4 col-sm-6 col-xs-12 mb-4 mt-2 position-relative"
            >
              <div
                id="panoramicxray"
                onMouseEnter={() => !webCamStatus[1] && handleMouseEnter(1)}
                onMouseLeave={() => !webCamStatus[1] && handleMouseLeave(1)}
                onDrop={handleDrop}
                onDragOver={(e) => e.preventDefault()}
                className={
                  "border justify-content-center align-items-center text-center"
                }
                style={{
                  width: "170px",
                  height: "120px",
                  cursor: "pointer",
                  caretColor: "transparent",
                  background:
                    !panoramicXRayPic &&
                    `url(${PanoramicXraySVG}) no-repeat center`,
                }}
              >
                {isHovered[1] && (
                  <div
                    className="position-absolute d-flex flex-column align-items-center justify-content-center"
                    style={{
                      width: "160px",
                      height: "110px",
                      backgroundColor: "rgba(256,256,256,0.8)",
                      top: "1px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                        width: "-webkit-fill-available",
                      }}
                    >
                      <CiCamera
                        size={30}
                        onClick={() => {
                          let temp = webCamStatus;
                          temp[1] = true;
                          setWebCamStatus([...temp]);
                          let temp2 = [...isHovered];
                          temp2[1] = false;
                          setIsHovered([...temp2]);
                          initializeCamera("panoramic", 1);
                        }}
                      />
                      <div
                        style={{
                          border: "1px solid rgba(0,0,0,0.1)",
                          position: "absolute",
                          height: "108%",
                          top: "0px",
                        }}
                      ></div>
                      <IoCloudUploadOutline
                        size={30}
                        onClick={() => {
                          let temp = [...isHovered];
                          temp[1] = false;
                          setIsHovered([...temp]);
                          let temp2 = [...webCamStatus];
                          temp2[1] = false;
                          setWebCamStatus([...temp2]);

                          inputRefPanoramic?.current?.click();
                        }}
                      />
                    </div>
                  </div>
                )}
                {imageUploadLoading[1] && panoramicXRayPic && (
                  <div
                    className="position-absolute"
                    style={{
                      width: "170px",
                      height: "120px",
                      backgroundColor: "rgba(256,256,256,0.4)",

                      zIndex: 99,
                      top: 0,
                    }}
                  >
                    <div
                      className="position-absolute z-1"
                      style={{ top: 25, left: 65, height: 50 }}
                    >
                      <Loader />
                    </div>
                  </div>
                )}
                {
                  <input
                    id="panoramicxray"
                    type="file"
                    accept="image/png, image/jpeg"
                    onChange={(event) => handleImageUpload(event)}
                    ref={inputRefPanoramic}
                    style={{ display: "none" }}
                  />
                }
                {!webCamStatus[1] ? (
                  <img
                    src={panoramicXRayPic || ""}
                    id="panoramicxray"
                    style={{
                      width: "auto",
                      height: "auto",
                      maxHeight: "110px",
                      maxWidth: "160px",
                    }}
                    // alt="panoramic x ray webcam"
                  />
                ) : (
                  <div>
                    <video
                      ref={(el) => (camRef.current["panoramic"] = el)}
                      autoPlay
                      playsInline
                    />
                    <canvas
                      ref={(el) => (canvasRef.current["panoramic"] = el)}
                      style={{ display: "none" }}
                    />
                  </div>
                )}
              </div>
              {webCamStatus[1] && (
                <div
                  className="d-flex justify-content-between"
                  style={{ width: "170px" }}
                >
                  <Tooltip title="Capture">
                    <IconButton
                      onClick={() => {
                        const canvas = canvasRef.current["panoramic"];
                        canvas.width = 170;
                        canvas.height = 115;

                        const context = canvas.getContext("2d");

                        context.drawImage(
                          camRef.current["panoramic"],
                          0,
                          0,
                          canvas.width,
                          canvas.height
                        );
                        const imageSrc = canvas.toDataURL("image/webp");

                        setPanoramicXRayPic(imageSrc);

                        convertToFile(imageSrc, "panoramic");
                        stopVideoStream("panoramic");
                        let temp2 = webCamStatus;
                        temp2[1] = false;
                        setWebCamStatus([...temp2]);
                        let temp = [...isHovered];
                        temp[1] = false;
                        setIsHovered([...temp]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <circle cx="256" cy="272" r="64" />
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM256 368a96 96 0 1196-96 96.11 96.11 0 01-96 96z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Switch Camera">
                    <IconButton
                      onClick={() => {
                        SwitchCamera("panoramic", 1);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M432 144h-59c-3 0-6.72-1.94-9.62-5l-25.94-40.94a15.52 15.52 0 00-1.37-1.85C327.11 85.76 315 80 302 80h-92c-13 0-25.11 5.76-34.07 16.21a15.52 15.52 0 00-1.37 1.85l-25.94 41c-2.22 2.42-5.34 5-8.62 5v-8a16 16 0 00-16-16h-24a16 16 0 00-16 16v8h-4a48.05 48.05 0 00-48 48V384a48.05 48.05 0 0048 48h352a48.05 48.05 0 0048-48V192a48.05 48.05 0 00-48-48zM316.84 346.3a96.06 96.06 0 01-155.66-59.18 16 16 0 01-16.49-26.43l20-20a16 16 0 0122.62 0l20 20A16 16 0 01196 288a17.31 17.31 0 01-2-.14 64.07 64.07 0 00102.66 33.63 16 16 0 1120.21 24.81zm50.47-63l-20 20a16 16 0 01-22.62 0l-20-20a16 16 0 0113.09-27.2A64 64 0 00215 222.64 16 16 0 11194.61 198a96 96 0 01156 59 16 16 0 0116.72 26.35z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Close Camera">
                    <IconButton
                      onClick={() => {
                        stopVideoStream("panoramic");
                        let temp2 = webCamStatus;
                        temp2[1] = false;
                        setWebCamStatus([...temp2]);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="ionicon"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" />
                      </svg>
                    </IconButton>
                  </Tooltip>
                </div>
              )}
              {!webCamStatus[1] && (
                <div className="text-center" style={{ width: "170px" }}>
                  Panoramic
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeethProfile;
